import React from 'react';



export const If: React.FC<any> = ({ condition = true, children }) => {
	if (!condition) return null;
	return children
}
